module.exports = __webpack_public_path__ + "static/media/tw.eb5ac137.svg";